import { Component, Input } from '@angular/core';

import { icons } from '@finnairoyj/fcom-ui-styles';

@Component({
  selector: 'fcom-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
})
export class IconComponent {
  @Input()
  category: keyof icons = 'svg-library';

  @Input()
  name: string = null;

  @Input()
  informative = false;

  private errorThrown = false;
  private icons = icons;

  get iconId(): string {
    return `${this.category as string}/${this.name}`;
  }

  get svgPath(): string | never {
    if (this.icons[this.category] && this.icons[this.category][this.name]) {
      return this.icons[this.category][this.name];
    }

    this.throwSingleError(`Invalid Icon: ${String(this.category)}/${this.name}`);
    return '';
  }

  // Throw an error in a timeout to stop it crashing other components but still report to sentry.
  throwSingleError(err): void {
    if (this.errorThrown) {
      return;
    }

    this.errorThrown = true;

    setTimeout(() => {
      throw new Error(err);
    }, 0);
  }
}
